import type { RouteRecordRaw } from 'vue-router'

const DataImportsPage = () => import('./pages/DataImportsPage.vue')

const importRoutes: RouteRecordRaw[] = [
  {
    name: 'data-imports',
    path: 'data-imports',
    component: DataImportsPage,
    meta: { requiresAuth: true },
  },
]

export default importRoutes
